import { SceneOptimizer, SceneOptimizerOptions, type Scene } from "@babylonjs/core";

/**
 * Auto-degrades render quality (SSAO first, then post-processing, then
 * hardware resolution scaling, etc. — Babylon's built-in priority order)
 * if the scene can't sustain `targetFrameRate`. This matters specifically
 * because this app runs unattended for long, screensaver-style stretches
 * on unknown hardware — graceful degradation is the right default rather
 * than an uncapped, possibly-struggling frame rate.
 *
 * `targetFrameRate` is set to the plan's stated *floor* (30fps), not its
 * 60fps target: this should only intervene when things are genuinely
 * struggling, not shave quality off hardware that's merely not hitting 60.
 */
export function startPerformanceGuard(scene: Scene): SceneOptimizer {
  const options = SceneOptimizerOptions.ModerateDegradationAllowed(30);
  const optimizer = new SceneOptimizer(scene, options);

  optimizer.onNewOptimizationAppliedObservable.add((optimization) => {
    console.info(
      `[Castaway] PerformanceGuard: applying "${optimization.getDescription()}" (priority ${optimization.priority}) — sustained frame rate was below the 30fps floor.`
    );
  });
  optimizer.onFailureObservable.add(() => {
    console.warn(
      `[Castaway] PerformanceGuard: exhausted all available optimizations and still can't reach 30fps on this hardware.`
    );
  });

  optimizer.start();
  return optimizer;
}
